import { Check } from 'lucide-react';
import { LATAM_COUNTRIES } from '../../utils/market';

/**
 * Moedas que o bot LATAM aceita (só visual, sem API), com a bandeira do país.
 * Mostra as que a XPag cobra (`available`); `value` são as marcadas. A última
 * marcada não desmarca: o bot sempre tem uma moeda para cobrar.
 */
export default function LatamCurrencies({ available, value, onChange, saving = false }) {
    const shown = LATAM_COUNTRIES.filter((c) => available.includes(c.currency));

    const toggle = (currency) => {
        const on = value.includes(currency);
        if (saving || (on && value.length === 1)) return;
        const next = on ? value.filter((c) => c !== currency) : [...value, currency];
        onChange(shown.map((c) => c.currency).filter((c) => next.includes(c)));
    };

    return (
        <div role="group" aria-label="Moedas aceitas" aria-busy={saving} className="inline-flex items-center gap-1">
            {shown.map((c) => {
                const on = value.includes(c.currency);
                const last = on && value.length === 1;
                return (
                    <button
                        key={c.currency}
                        type="button"
                        aria-pressed={on}
                        title={last ? 'O bot precisa aceitar ao menos uma moeda' : `${on ? 'Parar de aceitar' : 'Aceitar'} ${c.currency} (${c.name})`}
                        onClick={() => toggle(c.currency)}
                        className={`inline-flex items-center gap-1.5 h-7 px-2 rounded-md border text-[11px] font-medium whitespace-nowrap transition-colors ${
                            on
                                ? 'border-teal-500/60 bg-teal-500/15 text-white'
                                : 'border-white/10 text-white/45 hover:text-white hover:bg-white/[0.05]'
                        } ${last ? 'cursor-default' : ''}`}
                    >
                        <img alt="" className={`w-4 h-3 object-cover rounded-[2px] ${on ? '' : 'opacity-50'}`}
                            src={`https://flagcdn.com/w20/${c.flag}.png`} />
                        <span>{c.currency}</span>
                        {on && <Check size={11} strokeWidth={3} className="text-teal-300" />}
                    </button>
                );
            })}
        </div>
    );
}
